module.exports = global["$"] = require("-!/tmp/build_398b17a6/node_modules/expose-loader/index.js?jQuery!./jquery.js");